<template>
	<div class="zp-content">
		<div class="upload-div">
			<h3 style="text-align: left;">主页轮播图</h3>
			<div class="model-upload">
				<img-upload class="upload-margin" ref="modelPictureUrl" :imageUrl="ruleForm.modelPictureUrl" :limit="1"
					title="模型图(PNG)"></img-upload>
				<img-upload :imageUrl="ruleForm.scenePictureUrl" ref="scenePictureUrl" :limit="99" title="现场图">
				</img-upload>
			</div>
		</div>
		<div class="upload-div">
			<h3 style="text-align: left;">桥梁侧面图</h3>
			<img-upload class="upload-margin" :imageUrl="ruleForm.bridgeSidePictureUrl" ref="bridgeSidePictureUrl"
				:limit="99"></img-upload>
		</div>
		<div class="upload-div">
			<h3 style="text-align: left;">传感器布置图</h3>
			<div class="flex-upload">
				<div v-for="(item, index) in ruleForm.bridgeEquipmentTypePictures" :key="index">
					<img-uploadd class="flex-upload-margin" :isType="3" :options="options" :imageUrl="item.equipmentTypePictureUrl"
						:stlectId="item.equipmentTypeUuid" @getUuid="getUuid($event, index)"
						:ref="item.equipmentTypePictureUrl" :limit="1" @addUpload="addUpload"
						@removeUpload="removeUpload(index)" ></img-uploadd>
				</div>
			</div>
		</div>
		<div class="upload-div">
			<h3 style="text-align: left;">桥梁图纸</h3>
			<img-upload class="upload-margin" :imageUrl="ruleForm.bridgePictureUrl" ref="bridgePictureUrl" :limit="99">
			</img-upload>
		</div>
		<div class="upload-div">
			<h3 style="text-align: left;">桥名牌</h3>
			<img-upload class="upload-margin" :imageUrl="ruleForm.maybePicture" ref="maybePicture" :limit="99">
			</img-upload>
		</div>
	</div>
</template>

<script>
	import imgUpload from '@/views/components/upLoad/imgUpload.vue';
	import imgUploadd from '@/views/components/upLoad/imgUploadd.vue';
	export default {
		name: 'zhaopian',
		props: [],
		components: {
			imgUpload,
			imgUploadd
		},
		data() {
			return {
				ruleForm: {
					modelPictureUrl: [],
					scenePictureUrl: [],
					bridgeSidePictureUrl: [],
					bridgeEquipmentTypePictures: [{
						equipmentTypePictureUrl: [],
						equipmentTypeUuid: ''
					}],
					bridgePictureUrl: [],
					maybePicture:[],
				},
				rules: {},
				options: [],
			};
		},
		mounted() {
			// console.log(this.$store.state.user);
			// 获取设备类型信息
			this.getBiEquipmentType();
		},
		watch: {
			'ruleForm': {
				handler: function(val, oldVal) {
					console.log(val);
				},
				deep: true
			},
			'ruleForm.bridgeEquipmentTypePictures': {
				handler: function(val, oldVal) {
					console.log(val);
				},
				// immediate: true,
				deep: true
			}
		},
		methods: {
			// 移除
			removeUpload(index) {
				this.ruleForm.bridgeEquipmentTypePictures.splice(index, 1);
			},
			// 获取设备类型uuid
			getUuid(id, index) {
				this.ruleForm.bridgeEquipmentTypePictures[index].equipmentTypeUuid = id;
			},
			addUpload() {
				let obj = {
					equipmentTypePictureUrl: [],
					equipmentTypeUuid: ''
				};
				this.ruleForm.bridgeEquipmentTypePictures.push(obj);
			},
			// 获取设备类型信息
			async getBiEquipmentType() {
				const res = await this.$api.sendPost('/biEquipmentType/getBiEquipmentType', {});
				if (res.errcode == 0) {
					this.options = res.data.list;
				} else {
					this.options = [];
				}
				console.log(res);
			},
			// 提交照片录入
			async zhaoPianBC() {
				let data = {
					createByName: this.$store.state.user.accountName,
					createByUuid: this.$store.state.user.accountUuid,
					bridgeUuid: global.bridgeUuid
				};
				data.modelPictureUrl = this.$refs.modelPictureUrl.getString();
				data.scenePictureUrl = this.$refs.scenePictureUrl.getString();
				data.bridgeSidePictureUrl = this.$refs.bridgeSidePictureUrl.getString();
				data.bridgePictureUrl = this.$refs.bridgePictureUrl.getString();
				data.maybePicture = this.$refs.maybePicture.getString();
				let arr = JSON.parse(JSON.stringify(this.ruleForm.bridgeEquipmentTypePictures));
				let newArr = [];
				arr.map((item, index) => {
					if (item.equipmentTypePictureUrl.length > 0) {
						item.bridgeUuid = global.bridgeUuid;
						item.equipmentTypePictureUrl = item.equipmentTypePictureUrl[0].url;
					} else {
						item.equipmentTypePictureUrl = '';
					}
					newArr.push(item);
				});
				// var obj = {};
				//  newArr.reduce((item, next)=> {
				// 	obj[next.key] ? '' : obj[next.key] = true && item.push(next);
				// 	return item;
				// 	console.log(item);
				// 	console.log(item);
				// }, []);
				// console.log(newArr);
				data.bridgeEquipmentTypePictures = newArr;
				console.log(data);
				const res = await this.$api.sendPost('/biBridge/update', data);
				console.log('修改数据',res);
				if (res.errcode == 0) {
					this.$message.success(res.errmsg);
					this.$emit('updateIndex', '4');
				} else {
					this.$message.error(res.errmsg);
				}
			}
		}
	};
</script>
<style lang="scss" scoped>
	.zp-content {
		margin-left: 40px;
		height: 700px;
		overflow: auto;
	}

	h3 {
		font-size: 18px;
		color: #333333;
		margin-bottom: 20px;
	}

	.upload-div {
		margin-bottom: 40px;

		.model-upload {
			display: flex;

			.upload-margin {
				margin-right: 40px;
			}
		}
	}

	.flex-upload {
		display: flex;

		.flex-upload-margin {
			margin-right: 20px;
		}
	}
</style>
